import type { TickAxis } from '../../core/utils/formatter-by-ticks.js';
import type { AnyXYChartScale } from '../types/xy-chart-internals.js';

// TODO APPDEV-18188: remove when XYChart gains full scroll support
export function filterOutOfRangeTicks(
  tickAxis: TickAxis,
  scale: AnyXYChartScale | undefined,
  maxDim: number,
): TickAxis {
  if (!scale || !('bandwidth' in scale)) {
    return tickAxis;
  }

  const { ticks, formattedTicks, numericTicks } = tickAxis;
  const filteredTicks: string[] = [];
  const filteredFormatted: string[] = [];
  const filteredNumeric: number[] | undefined = numericTicks ? [] : undefined;

  for (let i = 0; i < ticks.length; i++) {
    const pos = scale(ticks[i]);
    if (pos !== undefined && pos < maxDim) {
      filteredTicks.push(ticks[i]);
      filteredFormatted.push(formattedTicks[i]);
      if (filteredNumeric && numericTicks) {
        filteredNumeric.push(numericTicks[i]);
      }
    }
  }

  return {
    ticks: filteredTicks,
    formattedTicks: filteredFormatted,
    numericTicks: filteredNumeric,
  };
}
